import { Container, Icon, Link, Text } from "@chakra-ui/react";
import { Link as GatsbyLink } from "gatsby";
import { ReactComponent as ESCDA2026Logo } from "src/assets/icons/ESCDA2026.svg";
import { useIsESCDA2026Enabled } from "src/hooks/useIsESCDA2026Enabled";

const LINK_URL = "/facturation-electronique";

export const ESCDA2026Banner = () => {
  const { isESCDA2026Enabled } = useIsESCDA2026Enabled();

  if (!isESCDA2026Enabled) {
    return null;
  }

  return (
    <Container
      alignItems="center"
      backgroundColor="primary-green"
      display={{
        base: "none",
        lg: "flex",
      }}
      gap="space-16"
      justifyContent="center"
      paddingY={12.33}
      width="100%"
    >
      <Icon alt="ESCDA2026" as={ESCDA2026Logo} height="auto" width={85} />

      <Text
        fontWeight="medium"
        color="monochrome-white"
      >
        Passez à la facturation électronique gratuitement avec Shine, votre Plateforme Agréée
      </Text>

      <Link
        as={GatsbyLink}
        to={LINK_URL}
        textDecorationLine="underline"
        color="monochrome-white"
        style={{
          textDecorationSkipInk: "none",
          textUnderlinePosition: "from-font",
        }}
      >
        Je découvre
      </Link>
    </Container>
  );
};
